import React, {useState, useEffect, useRef} from 'react';
import { Table } from 'antd';
import { TablePaginationConfig } from 'antd/lib/table';
import type { TableProps } from 'antd';
import SPTableActionBar from '../table-action-bar';

import { useNotificationListTemplate } from 'hooks/notification/notificationList';

import {DEFAULT_PAGE_INFO} from "../../../../consts";
import emiter, {_EVENTS} from "../../../../events";

interface IComponentProps {
  enums?: any;
  permission?: any;
}
interface INotificationListTemplateTableDataType {
    key?: any;
    id?: any;
    name?: any;
    state?: any;
    createDate?: any;
};
const SPTable: React.FC<IComponentProps> = (props) => {
  const { enums, permission } = props;

  const columns: TableProps<INotificationListTemplateTableDataType>['columns'] = [
    // { title: '供应商名称', dataIndex: 'supplier_name', key: 'supplier_name' },
    { title: '通知时间', width: 100,  dataIndex: 'time', key: 'time' },
    { title: '通知分类', width: 80, dataIndex: 'item_type_name',key: 'item_type_name' },
    { title: '通知标题', width: 100, dataIndex: 'title', key: 'title' },
    { title: '状态', width: 50, dataIndex: 'read_status', key: 'read_status' },
    { title: '通知内容', width: 150, dataIndex: 'brief', key: 'brief', render: (text: any, record: any) => text === '' ? record.content : text ,ellipsis: true},
    { title: '操作', width: 100, key: 'action', render: (_, record) => (<SPTableActionBar permission={permission} data={record} />)},
  ];

  const [data, setData] = useState<any>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPageData, setCurrentPageData] = useState<any>();
  const dataRef = useRef({});


  const { search, tablePagination, onSearchAction } = useNotificationListTemplate();

  const load = (params?: any) => {
      params =  Object.assign({...DEFAULT_PAGE_INFO}, {...dataRef.current}, params);
      search(params).then((data: any) => {
          const res = data?.data
          setData(res?.list || []);
          setTotalCount(res?.total);
          dataRef.current = params
          setCurrentPageData({page: res.page || 1, page_size: res.page_size || 10});
      })
  };


  // TODO: 清空再搜索，翻页有问题
  const onPagination = (pagination: TablePaginationConfig) => {
    tablePagination(Object.assign(dataRef.current, {
        page: pagination.current,
        page_size: pagination.pageSize
    }))
  };

  useEffect(() => {
      emiter.on(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.SEARCH, load);
      return () => {
          emiter.removeAllListeners(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.SEARCH)
      }
  }, []);

  return (
    <>
        <Table
            size='middle'
            columns={columns}
            dataSource={data}
            rowKey={cols => cols.id}
            pagination={{ total:totalCount, showSizeChanger: true, showQuickJumper: true,showTotal:total => `共 ${total} 条数据`,current:currentPageData?.page,pageSize:currentPageData?.page_size }}
            onChange={onPagination}
          />
    </>
  );
};

export default SPTable;

